<template>
	<!-- 评论筛选 -->
	<div class="lwInfo">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!--  @click="back" -->
					<div class="arrImg" @click='$router.go(-1)'>
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile"><span v-for="(itm,idx) in title" v-if="idx<10">{{itm}}</span></p>
				</div>
			</div>
		</van-sticky>
		<div class="par_view">
			<div>
				<div class="rightSelect">
					<!-- <div>
						<p>全部</p>
						<img src="../../assets/img/selectArr.png" alt="">
					</div> -->
					<div @click="firstSelectBox">
						<p v-model="firstselectValue">{{firstselectValue}}</p>
						<img src="../../assets/img/selectArr.png" alt="">
					</div>
					<div @click="scoreSelectBox">
						<p>{{scoreSelectValue}}</p>
						<img src="../../assets/img/selectArr.png" alt="">
					</div>
				</div>
				<!-- 时间筛选 -->
				<div class="selectItem" v-show="firstSelect">
					<div class="selectItem_left" @click="closeBox"></div>
					<div class="selectItem_right">
						<div class="selectItem_right_title">
							<img src="../../assets/img/close.png" alt="" @click="closeBox">
							<p>全部</p>
						</div>
						<ul>
							<li v-for="(selectItem,index) in firstSelectLists" :key="index" @click="firstselectItemFn(selectItem.txt,selectItem.id)">
								<div>
									<img src="../../assets/img/datalw.png" alt="" v-show="firstselectIndex == index ? false : true" />
									<img src="../../assets/img/dataLw_active.png" alt="" v-show="firstselectIndex == index ? true : false">
								</div>
								<span :class="firstselectIndex == index ? 'active_color' : '' ">{{selectItem.txt}}</span>
							</li>
						</ul>
					</div>
				</div>
				<!-- 分数筛选 -->
				<div class="selectItem" v-show="scoreSelect">
					<div class="selectItem_left" @click="closeBox"></div>
					<div class="selectItem_right">
						<div class="selectItem_right_title">
							<img src="../../assets/img/close.png" alt="" @click="closeBox">
							<p>全部</p>
						</div>
						<ul>
							<li v-for="(selectItem,index) in scoreList" :key="index" @click="scoreListItemFn(selectItem.txt,selectItem.id)">
								<!-- <div>
									<img src="../../assets/img/datalw.png" alt="" v-show="scoreSelectIndex == index ? false : true" />
									<img src="../../assets/img/dataLw_active.png" alt="" v-show="scoreSelectIndex == index ? true : false">
								</div> -->
								<span :class="scoreSelectIndex == index ? 'active_color' : '' " style="text-align: center;">{{selectItem.txt}}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!-- 实时讨论列表 -->
			<div class="forumListBox">
				<div class="forumListItem" v-for="(itm,idx) in booksCommentList.comment_list">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+itm.avatar" alt="">
								<div class="timeInfo">
									<span class="wname">{{itm.nickname}}</span>
									<p><span>{{formatDateTime(itm.createtime)}}</span></p>
								</div>
							</div>
							<p class="bookName">
								<span v-for="(titItm,titIdx) in title" v-if="titIdx < 12">{{titItm}}</span>
							</p>
						</div>
						<div class="forum_top_right">
							<span v-if="itm.chapter_number != null">第<i>{{itm.chapter_number}}</i>章</span>
							<span><i>{{itm.c_score}}</i>分</span></div>
					</div>
					<div class="forum_middle">
						<p>{{itm.c_content}} </p>
						<div class="btnHf">
							<!-- <img src="../../assets/img/hbicon.png" alt="" class="hbicon" @click="tostShow"> -->
							<img src="../../assets/img/xiaoxi.png" alt="" 
								class="xiaoxi" 
								@click="no_huifu? '' : toReply(itm.id,itm.user_id,itm.nickname,itm.c_content)">
						</div>
					</div>
					<div class="er_reply" v-if="itm.children">
						<div :class="!itm.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in itm.children' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="content">{{it.c_content}}</p>
							<p class="time">
								<span class="er_reply_time">{{formatDateTime(it.createtime)}}</span>
							</p>
						</div>
					</div>
					<div v-if="itm.children && itm.children.length > 3" @click="showComment(idx)" class="more_comment">
						<span>
							{{!itm.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="comment_input">
			<div class="input_hf">
				<input type="text" ref="replyValue" placeholder="回复TA..." v-model="content"/>
				<!-- <img src="../../assets/img/sdadd.png" alt=""> -->
			</div>
			<span @click="goReply">发送</span>
		</div>
		<!-- 弹窗 -->
		<div class="tostBoxFather" v-show="tostShowBox">
			<div class="tostBoxson">
				<div class="yunjinbiBox">
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''" v-for="(item, index) in yunjinbiList" :key="index"
					 @click="itemyunjinbiFn(index)">{{item}}
						<img src="../../assets/img/jinbi.png" alt="" class="jinbi">
					</div>
				</div>
				<div class="zsTxt">
					<p>这是人家那肾换来的红包，请慢慢享用~</p>
					<p>注：此项操作会扣除5%的手续费</p>
				</div>
				<div class="submitBox">
					<img src="../../assets/img/flower.png" alt="" class="flower">
					<button @click="submitBtn">提交</button>
				</div>
			</div>
			<div class="header_img">
				<img src="../../assets/img/pltost.png" alt="" />
			</div>
		</div>
		<div class="mask" v-show="tostShowBox"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				tapshowBox: false,
				scoreSelect: false,
				scoreSelectValue: '不限分数',
				scoreSelectIndex: '',
				firstSelect: false,
				firstselectIndex: 0, //选中索引
				firstselectValue: '不限时间',
				firstSelectLists: [{
					id: 0,
					txt: "不限时间"
				}, {
					id: 1,
					txt: "一周之内"
				}, {
					id: 2,
					txt: "一月之内"
				}, {
					id: 3,
					txt: "半年之内"
				}, ],
				scoreList: [{
					id: '',
					txt: '不限分数'
				}, {
					id: -2,
					txt: '-2分'
				}, {
					id: -1,
					txt: '-1分'
				}, {
					id: 0,
					txt: '0分'
				}, {
					id: 1,
					txt: '1分'
				}, {
					id: 2,
					txt: '2分'
				}, {
					id: 3,
					txt: '3分'
				}],
				tostShowBox: false, //弹框
				itemyunjinbi: 0, //弹框 云锦币
				yunjinbiList: ["流星", "卫星", "行星", "恒星", "彗星", "M78星云", "银河系", "彗星"],
				booksCommentList: {},

				pid: '',
				reply_id: '',
				nickname: '',
				c_content: '',
				content:'',
				title_name: '',
				book_id: '',
				no_huifu: false,
			}
		},
		created() {
			this.title = this.$route.query.txt;
			if(this.$route.query.title_name && this.$route.query.title_name == 'fcpl'){ //发出评论
				this.title_name = this.$route.query.title_name;
				this.book_id = this.$route.query.books_id;
				this.my_comment_list();
				this.no_huifu = true;
			}else{ //收到评论
				this.books_comment_list();
				this.book_id = this.$route.query.books_id;
			}
		},
		methods: {
			// 去回复
			goReply() {
				if (this.$refs.replyValue.value) {
					this.content = this.$refs.replyValue.value
					this.add_comment()
					this.$refs.replyValue.value = ''
				} 
				this.pid = ''
			},
			// 回复
			toReply(id, user_id, nickname, c_content) {
				this.pid = id
				this.reply_id = user_id
				this.nickname = nickname
				this.c_content = c_content
			},
			//展示更多评论
			showComment(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.booksCommentList.comment_list[index].show_comment) {
					this.$set(this.booksCommentList.comment_list[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.booksCommentList.comment_list[index].show_comment = !this.booksCommentList.comment_list[index].show_comment;
				}
			},
			add_comment() {
				this.$axios.post(this.$api.add_comment, {
					pid: this.pid,
					content: this.content,
					book_id: this.book_id,
					score: 2,
				}).then(res => {
					console.log(res.data.msg)
					if(res.data.code == 1){
						this.content = '';
						if(this.title_name){
							this.my_comment_list(); //发出评论
						}else{
							this.books_comment_list(); //收到评论
						}
						this.$toast(res.data.msg);
					}else{
						this.$toast(res.data.msg);
					}
				})
			},
			closeBox(){
				this.firstSelect =false;
				this.scoreSelect =false;
			},
			firstSelectBox() { //时间下拉框选项 显示 -- 1
				this.firstSelect = !this.firstSelect
			},
			scoreSelectBox() { //分数 下拉框选项 显示 -- 1
				this.scoreSelect = !this.scoreSelect
			},
			firstselectItemFn(value, id) { //时间下拉框选择 -- 1
				this.firstselectValue = value;
				this.firstselectIndex = id;
				this.firstSelect = !this.firstSelect;
				if(this.title_name){ //发出评论
					this.$axios.post(this.$api.my_comment_list, {
						time: this.firstselectIndex,
						books_id: Number(this.$route.query.books_id),
					}).then(res => {
						this.booksCommentList = res.data.data
					})
				}else{ //收到评论
					this.$axios.post(this.$api.books_comment_list, {
						time: this.firstselectIndex,
						books_id: Number(this.$route.query.books_id),
					}).then(res => {
						this.booksCommentList = res.data.data
					})
				}
				
			},
			scoreListItemFn(value, id) { //分数下拉框选择 -- 1 
				this.scoreSelectValue = value;
				this.scoreSelectIndex = id;
				this.scoreSelect = !this.scoreSelect;
				if(this.title_name){ //发出评论
					this.$axios.post(this.$api.my_comment_list, {
						score: this.scoreSelectIndex,
						books_id: Number(this.$route.query.books_id),
					}).then(res => {
						this.booksCommentList = res.data.data
					})
				}else{ //收到评论
					this.$axios.post(this.$api.books_comment_list, {
						score: this.scoreSelectIndex,
						books_id: Number(this.$route.query.books_id),
					}).then(res => {
						this.booksCommentList = res.data.data
					})
				}
				
			},
			tapshow() {
				this.tapshowBox = !this.tapshowBox
			},
			tostShow() {
				this.tostShowBox = !this.tostShowBox
			},
			itemyunjinbiFn(data) {
				this.itemyunjinbi = data
			},
			submitBtn() { //弹唱提交按钮
				this.tostShowBox = !this.tostShowBox
			},
			back() {
				this.$router.push('/mylw')
			},
			books_comment_list() { //收到评论
				this.$axios.post(this.$api.books_comment_list, {
					time: this.firstselectIndex,
					books_id: Number(this.$route.query.books_id),
					score: this.scoreSelectIndex,
				}).then(res => {
					this.booksCommentList = res.data.data
				})
			},
			my_comment_list() { //发出评论
				this.$axios.post(this.$api.my_comment_list, {
					time: this.firstselectIndex,
					books_id: Number(this.$route.query.books_id),
					score: this.scoreSelectIndex,
				}).then(res => {
					console.log(res)
					this.booksCommentList = res.data.data
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .4);
	}

	.lwInfo {
		height: 100vh;
		background-color: #fff;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//筛选
		.rightSelect {
			background-color: #fff;
			padding: 10px 0;
			margin-bottom: 20px;
			display: flex;

			div {
				width: 150px;
				border: 0;
				margin: 10px 16px;
				padding: 5px 20px;
				font-size: 30px;
				/*px*/
				border-radius: 8px;
				border: 1px solid #fa7298;
				/*no*/
				width: 160px;
				position: relative;

				p {
					display: inline-block;
					color: #fa7298;
				}

				img {
					width: 20px;
					position: absolute;
					right: 20px;
					top: 50%;
					transform: translateY(-50%);
				}
			}

		}

		//下拉列表
		.selectItem {
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			position: fixed;
			top: 160px;
			right: 0px;
			display: flex;
			z-index: 100;

			.selectItem_left {
				width: 30vw;
				background-color: rgba(0, 0, 0, .3);
			}

			.selectItem_right {
				flex: 1;
				background-color: #fff;
				z-index: 100;

				.selectItem_right_title {
					height: 80px;
					line-height: 80px;
					width: 100%;
					position: relative;

					img {
						position: absolute;
						top: 50%;
						left: 20px;
						transform: translateY(-50%);
						width: 25px;
					}

					p {
						text-align: center;
						width: 100%;
						font-size: 30px;
						/*px*/
						font-weight: 600;
					}
				}

				ul {
					background-color: #fff;

					position: relative;
					padding: 0 20px;

					li {
						padding: 0px 20px;
						position: relative;
						text-align: center;
						line-height: 80px;
						color: #a3a3a3;
						display: flex;

						div {
							width: 20%;
							margin: 0 20px;

							img {
								width: 30px;
								padding-right: 10px;
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
							}
						}

						span {
							flex: 1;
							font-size: 30px;
							/*px*/
							text-align: left;
							padding-left: 40px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/
						}
					}

					.active_color {
						color: #3d3d3d;
					}
				}
			}
		}
		.par_view{
			height:calc(100vh - 160px);
			width:100%;
			overflow-y: auto;
			padding-bottom: 120px;
			box-sizing: border-box;
		}

		// 弹窗
		.tostBoxFather {
			background-color: transparent;
			margin-top: 10px;
			position: fixed;
			bottom: -10px;
			z-index: 100;
			height: 700px;

			.tostBoxson {
				position: absolute;
				top: 128px;
				left: 0;
				background-color: #fff;
				width: 100vw;

				// 云锦币
				.yunjinbiBox {
					overflow: hidden;
					padding: 20px 16px;
					padding-bottom: 0;

					.yunjinbi {
						width: calc((100vw - 88px) / 3);
						box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .3);
						/*no*/
						border: 1px solid #e5e5e5;
						/*no*/
						padding: 20px 0px;
						text-align: center;
						margin-right: 20px;
						line-height: 60px;
						border-radius: 10px;
						float: left;
						margin-bottom: 20px;
						color: #3d3d3d;
						position: relative;

						.yunjintxt {
							position: absolute;
							top: 50%;
							width: 100px;
							transform: translateY(-50%);
						}

						.jinbi {
							position: absolute;
							top: 50%;
							left: 50%;
							width: 50px;
							transform: translate(-50%, -50%);
						}
					}

					.yunjinbi.active {
						box-shadow: none;
						background-color: #fff8fa;
						border: 1px solid #fa7298;
						/*no*/
						color: #000000;
					}

					.yunjinbi:nth-child(3n) {
						margin-right: 0;
					}
				}
			}

			.zsTxt {
				padding: 0px 16px;

				p {
					line-height: 60px;
					color: #b2b2b2;
					font-size: 28px;
					/*px*/
					border-bottom: 2px solid #f0f0f0;
					/*no*/
				}

				p:last-child {
					border-bottom: 0;
				}
			}

			//提交
			.submitBox {
				padding-top: 80px;
				padding-bottom: 40px;
				text-align: center;
				position: relative;

				.flower {
					position: absolute;
					top: 20px;
					left: 20%;
					width: 100px;
				}

				button {
					width: 90%;
					height: 60px;
					line-height: 60px;
					color: #fff;
					background-color: #FF4081;
					border: 0;
					font-size: 30px;
					/*px*/
					border-radius: 10px;
				}
			}

			.header_img {
				position: absolute;
				top: 4px;
				left: 0;

				img {
					width: 100vw;
				}
			}
		}

		//实时讨论
		.forumListBox {
			padding: 0 16px;

			.forumListItem:last-child {
				border-bottom: 0px;
			}

			.forumListItem {
				padding-bottom: 24px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				background-color: #fff;

				.forum_top {
					display: flex;
					padding: 24px 0;
					justify-content: space-between;
					padding-bottom: 14px;

					.forum_top_left {
						flex: 1;
						display: flex;
						justify-content: space-between;

						.userImg {
							overflow: hidden;
							display: flex;

							img {
								margin: 10px;
								;
								width: 60px;
								height: 60px;
								border-radius: 50%;
								-webkit-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
								/*no*/
								-moz-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
								/*no*/
								box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
								/*no*/
								float: left;
							}

							.timeInfo {
								color: #a3a3a3;
								flex: 1;

								.wname {
									display: inline-block;
									// line-height: 80px;
									padding-left: 24px;
									// float: right;
									color: #000;
									font-size: 28px;
									/*px*/
								}

								p {
									padding-top: 10px;
									padding-left: 20px;

									.time {
										padding-left: 10px;
									}
								}
							}
						}

						.bookName {
							flex: 1;
							text-align: left;
							padding-left: 10px;
							// line-height: 80px;
							color: #000;
							font-size: 28px;
							/*px*/
						}
					}

					.forum_top_right {
						width: 160px;
						text-align: right;
						// line-height: 80px;
						// color: #b8b8b8;
						color: #737373;
						font-size: 28px;

						/*px*/
						span {
							padding-right: 10px;

							i {
								font-style: normal;
								color: #81c5f7;
							}
						}

						span:last-child {
							padding: 0;
						}
					}
				}

				.forum_middle {
					position: relative;

					p {
						color: #000;
						line-height: 50px;
						font-size: 26px;/*px*/
					}

					.btnHf {
						// width: 100px;
						position: absolute;
						bottom: -10px;
						right: 0;
						.xiaoxi {
							width: 50px;
						}

						.hbicon {
							width: 60px;
						}
					}
				}
				.er_reply {
					color: #767676;
					padding: 10px 30px;
					border-radius: 4px;
					.list_item {
						line-height: 50px;
						padding:0 30px;
						box-sizing: border-box;
						border-bottom: 1px solid #fff;
						background-color: #f0f0f0;
						
						.top_text{
							width:100%;
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							
							.name{
								color: #3d3d3d;
							}
							
							.floor{
								color: #ff4081;
							}
						}
						
						.content{
							overflow: hidden;
							width:100%;
							max-height:95px;
							// word-break: break-word;
							// line-clamp: 1;
							// -webkit-line-clamp: 1;
							// display: -webkit-box;
							// -webkit-box-orient: vertical;
						}
						
						.time{
							width:100%;
							display: flex;
							justify-content: flex-end;
							
							
							.er_reply_time {
								font-size: 24px;
								/*px*/
								color: #848484;
								margin-left: 20px;
							}
						}
					}
					
					.list_item:last-child{
						border-bottom: 0;
					}
					
					.threelist{
						display: none;
					}
					.threelist:nth-child(1){
						display: block;
					}
					.threelist:nth-child(2){
						display: block;
					}
					.threelist:nth-child(3){
						display: block;
					}
				}
				
				.more_comment {
					padding: 14px 10px;
					color:#666666;
					text-align: center;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					color: #ff4081;
					
					img{
						width:25px;
						margin-left:10px;
					}
				}
			}
		}


	}

	// 说点啥
	.comment_input {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 100vw;
		height: 80px;
		padding: 20px 0;
		background-color: #fff;
		border-top: 1px solid #f0f0f0;

		/*no*/
		.input_hf {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			width: 80%;
			margin-left: 16px;
			height: 80px;
			line-height: 80px;
			border-radius: 80px;
			position: relative;
			border: 1px solid #fa7298;

			/*no*/
			input {
				width: 100%;
				background-color: transparent;
				padding-left: 20px;
				border-radius: 80px;
				box-sizing: border-box;
				padding-right: 20px;
			}

			img {
				position: absolute;
				top: 50%;
				right: 20px;
				transform: translateY(-50%);
				width: 50px;
			}
		}

		span {
			text-align: center;
			position: absolute;
			top: 50%;
			right: 10px;
			transform: translateY(-50%);
			background-color: #fa7298;
			color: #fff;
			padding: 15px 30px;
			border-radius: 20px;
		}
	}
</style>
